'use client';

import { VariantProps } from 'class-variance-authority';
import { cn } from '@lib/utils';
import React, { useCallback } from 'react';
import { useFullMenu } from './use-full-menu';
import { linkVariants } from './style';
import { TrackedAnchor } from '@/components/ancher';
import { TrackedEventProps } from '@/constants';

export type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> &
  VariantProps<typeof linkVariants> &
  TrackedEventProps;

const FullMenuLink = ({
  href,
  children,
  className,
  size,
  label,
  position,
  onClick,
  ...props
}: LinkProps) => {
  const { toggle } = useFullMenu();

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      toggle();
      onClick?.(e);
    },
    [toggle, onClick],
  );

  return (
    <TrackedAnchor
      label={label}
      position={position}
      href={href ?? ''}
      className={cn(linkVariants({ size, className }))}
      prefetch={false}
      onClick={handleClick}
      {...props}
    >
      {children}
    </TrackedAnchor>
  );
};

export default FullMenuLink;
